"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VarianceAttributeTypes = exports.ProductRecommenderTypes = void 0;
const ProductRecommenderTypes = exports.ProductRecommenderTypes = {
  BEST: 'best',
  SPECIFIC: 'specific',
  SPECIFIC_BY_ATTRIBUTES: 'specific_by_attributes'
};
const VarianceAttributeTypes = exports.VarianceAttributeTypes = {
  fill_up_when_not_set: 'Ignore variance attribute',
  filter_when_not_set: 'Recommend fewer products'
};